export default async (context, { redirect }) => {
    if(context.statusButton) {
        if(context.phone.indexOf('+') === -1) {
            await context.auth_phone_get(context, { redirect })
        } else {
            context.phone = await context.phone.slice(1)
            await context.auth_phone_get(context, { redirect })
        }

    }
}